<template>
    <div class="game-wrapper">
        <router-view></router-view>
        <MyLogin ref="mylogin" @successFn="getMyInfo" />
        <MyBind />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { GetMyInfo, GetBinds } from '../../api'
import MyLogin from '../../components/login'
import MyBind from '../../components/bind'
export default {
    name: 'Game',
    components: {
        MyLogin,
        MyBind
    },
    computed: {
        ...mapState(['userinfo', 'bindlist'])
    },
    methods: {
        ...mapMutations({ setUser: 'SETUSER', setBinds: 'SETBINDS' }),
        async getMyInfo() {
            const res = await GetMyInfo();
            // 已登录
            if (res) {
                this.setUser(res);
                this.getBinds();
            }
        },
        async getBinds() {
            const res = await GetBinds();
            if (res) {
                this.setBinds(res);
            }
        }
    },
    mounted() {
        // 获取主视图
        this.getMyInfo();
    }
}
</script>

<style lang="scss" scoped>
.icon {
    background-image: url('https://static.web.sdo.com/xuezu/pic/20221201_Game/icon.png');
    background-repeat: no-repeat;
    background-size: 20rem 20rem;
}

.game-wrapper {
    position: relative;
}
</style>